import React, { createContext, useContext, ReactElement } from "react";
import { Grid } from "@compass/core";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import type { DraggableAttributes, DraggableSyntheticListeners } from "@dnd-kit/core";


export const DashboardGrid: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <Grid container spacing="lg">{children}</Grid>
);

//Sortable item context
type SortableCtx = { attributes: DraggableAttributes; listeners: DraggableSyntheticListeners } | null;
const SortableItemContext = createContext<SortableCtx>(null);
export const useSortableItem = () => useContext(SortableItemContext);

//SortableCard
export const SortableCard: React.FC<{ id: string; children: React.ReactNode }> = ({ id, children }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

    const style: React.CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.9 : 1,
        width: "100%"
    };

    return (
        <SortableItemContext.Provider value={{ attributes, listeners }}>
            <div ref={setNodeRef} style={style}>
                {children}
            </div>
        </SortableItemContext.Provider>
    );
};

//DraggableHandle
export const DraggableHandle: React.FC<{ children: ReactElement; sx?: React.CSSProperties }> = ({ children, sx }) => {
    const ctx = useSortableItem();
    if (!ctx) return children;
    const { attributes, listeners } = ctx;
    return React.cloneElement(children, {
        ...attributes,
        ...listeners,
        style: { cursor: "grab", ...(children.props.style || {}), ...(sx || {}) }
    });
};
